import { YouTubeEmbed } from '../../how-to-videos/YouTubeEmbed.jsx';

function parseYouTubeId(raw) {
  const value = String(raw || '').trim();
  if (!value) return '';
  if (/^[\w-]{11}$/.test(value)) return value;
  try {
    const url = new URL(value);
    const host = url.hostname.replace(/^www\./, '');
    if (host === 'youtu.be') {
      return url.pathname.split('/').filter(Boolean)[0] || '';
    }
    if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
      const fromQuery = url.searchParams.get('v');
      if (fromQuery) return fromQuery;
      const parts = url.pathname.split('/').filter(Boolean);
      if (parts[0] === 'embed' || parts[0] === 'shorts' || parts[0] === 'live') {
        return parts[1] || '';
      }
    }
  } catch {
    return '';
  }
  return '';
}

const POINTS = [
  { icon: 'fa-landmark', label: 'Belediye imar verisi' },
  { icon: 'fa-layer-group', label: 'Yapı alternatifleri' },
  { icon: 'fa-cube', label: '3D görselleştirme' },
];

function PlayIcon() {
  return (
    <svg viewBox="0 0 72 72" width="72" height="72" aria-hidden="true" focusable="false">
      <circle cx="36" cy="36" r="34" fill="rgba(7, 30, 55, 0.72)" stroke="rgba(147, 197, 253, 0.55)" strokeWidth="2" />
      <path d="M30 24L50 36L30 48V24Z" fill="#7dd3fc" />
    </svg>
  );
}

export function LandingProjeOlustur({ assets = {}, appBase = '' }) {
  const editorUrl = `${appBase}/bina-ciz/`;
  const videoUrl = (assets.binaCizVideo || '').trim();
  const youtubeId = parseYouTubeId(videoUrl);
  const akisSrc = (assets.binaCizAkis || '').trim();

  return (
    <article class="pp-landing-proje" aria-labelledby="landing-proje-title">
      <div class="pp-landing-inner pp-landing-proje__inner">
        <div class="pp-landing-proje__hero">
          <div class="pp-landing-proje__copy">
            <div class="pp-landing-proje__kicker">
              <span class="pp-landing-proje__eyebrow">
                <i class="fas fa-cube" aria-hidden="true" />
                3D Bina Çiz
              </span>
              <span class="pp-landing-proje__badge">Ücretsiz</span>
            </div>
            <h2 class="pp-landing-proje__title" id="landing-proje-title">
              Proje Oluştur
            </h2>
            <p class="pp-landing-proje__body">
              Belediye e-İmar verilerindeki TAKS, KAKS (emsal), kat sayısı ve çekme mesafelerini
              kullanarak arsanıza ne kadar ve nasıl yapı yapılabileceğini anında görün. Sistem,
              imar koşullarına göre parsele uygun yapı alternatifleri oluşturur ve projeyi 3D
              harita üzerinde görselleştirir.
            </p>
            <ul class="pp-landing-proje__points">
              {POINTS.map((item) => (
                <li class="pp-landing-proje__point" key={item.label}>
                  <i class={`fas ${item.icon}`} aria-hidden="true" />
                  <span>{item.label}</span>
                </li>
              ))}
            </ul>
            <a class="pp-landing-hero__cta pp-landing-proje__cta" href={editorUrl}>
              Hemen Kullan
              <i class="fas fa-arrow-right" aria-hidden="true" />
            </a>
          </div>

          <div class="pp-landing-proje__media">
            {youtubeId ? (
              <YouTubeEmbed
                className="pp-landing-proje__video pp-landing-proje__video--embed"
                videoId={youtubeId}
                title="Proje Oluştur tanıtım videosu"
              />
            ) : videoUrl ? (
              <video
                class="pp-landing-proje__video"
                src={videoUrl}
                controls
                playsInline
                preload="metadata"
                poster={akisSrc || undefined}
              >
                Tarayıcınız video oynatmayı desteklemiyor.
              </video>
            ) : (
              <div class="pp-landing-proje__video-ph" role="img" aria-label="Tanıtım videosu yakında">
                <PlayIcon />
                <span class="pp-landing-proje__video-ph-label">Video yakında</span>
              </div>
            )}
          </div>
        </div>

        {akisSrc ? (
          <figure class="pp-landing-proje__banner">
            <img
              src={akisSrc}
              alt="Proje Oluştur: arsa ve imar verileri, strateji alternatifleri ve 3D görselleştirme"
              loading="lazy"
              decoding="async"
            />
          </figure>
        ) : null}
      </div>
    </article>
  );
}
